<template>
  <div>
    <div class="row">
      <div class="col">
        <div>
          <div class="form-group">
            <input
              v-model="searchText"
              class="form-control form-control-lg"
              type="text"
              placeholder=".form-control-lg"/>
          </div>
          <button type="button" class="btn btn-primary" v-on:click="search">Buscar</button>
          <form ref="formSearch" v-if="!viewSearch" v-on:change="getData()">
            <div class="form-group">
                <select class="form-control" v-model="amountRegister">
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="150">150</option>
                    <option value="200">200</option>
                </select>
            </div>
            <p>Total de rounds: {{listRound.total}}</p>
            
          </form>
          <form ref="formSearch2" v-else>
            <div class="form-group">
                <select class="form-control" v-model="amountRegister">
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="150">150</option>
                    <option value="200">200</option>
                </select>
            </div>
            <p>Total de rounds: {{resSearch.total}}</p>

          </form>
        </div>
      </div>
    </div>


    <div class="row" v-if="!viewSearch">
      <div class="col">

        <table class="table table-hover" v-if="listRound">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Block</th>
              <th scope="col">Course</th>
              <th scope="col">Theme</th>
              <th scope="col">Amount</th>
              <th scope="col">Correct</th>
              <th scope="col">Black</th>
              <th scope="col">Wrong</th>
              <th scope="col">Score</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="round in listRound.data" :key="round.id">
              <th scope="row"> {{ round.id }}</th>
              <td>
                <div class="imgav">
                  <div class="cAvatar">
                    <img :src="appDomainImg + 'profile/15.' + round.student.user.avatar" class="cImage"/>
                  </div>
                </div>
              </td>
              <td>{{ round.student.user.name}}</td>
              <td>
                {{ round.student.user.email}}
                <div v-on:click="searchEmail(round.student.user.email)">Buscar</div>
              </td>
              <td>{{ round.block.name}}</td>
              <td>{{ round.course.name}}</td>
              <td>{{ round.team.name}}</td>
              <td>{{ round.amount_questions}}</td>
              <td>{{ round.correct_answers}}</td>
              <td>{{ round.blank_answers}}</td>
              <td>{{ round.wrong_answers}}</td>
              <td>{{ round.score}}</td>
              <td>{{ round.created_at}}</td>
              <td> </td>
              <td> </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col">
        <p>search</p>
        <div class="row">
          <div class="col">
            <p>Total de preguntas: {{resSearch.total}}</p>
          </div>
        </div>
        <table class="table table-hover" v-if="listRound">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Block</th>
              <th scope="col">Course</th>
              <th scope="col">Theme</th>
              <th scope="col">Amount</th>
              <th scope="col">Correct</th>
              <th scope="col">Black</th>
              <th scope="col">Wrong</th>
              <th scope="col">Score</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(round, index) in resSearch.data" :key="round.id">
              <th scope="row"> {{ index+1 }}</th>
              <th scope="row"> {{ round.id }}</th>
              <td>
                <div class="imgav">
                  <div class="cAvatar">
                    <img :src="appDomainImg + 'profile/15.' + round.student.user.avatar" class="cImage"/>
                  </div>
                </div>
              </td>
              <td>{{ round.student.user.name}}</td>
              <td>{{ round.student.user.email}}</td>
              <td>{{ round.block.name}}</td>
              <td>{{ round.course.name}}</td>
              <td>{{ round.team.name}}</td>
              <td>{{ round.amount_questions}}</td>
              <td>{{ round.correct_answers}}</td>
              <td>{{ round.blank_answers}}</td>
              <td>{{ round.wrong_answers}}</td>
              <td>{{ round.score}}</td>
              <td>{{ round.created_at}}</td>
              <td> </td>
              <td> </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
//import { mapState } from "vuex";
import axios from 'axios'


export default {
  components: {
  },
  data() {
    return {
      listRound: [],
      searchText: "",
      resSearch: [],
      viewSearch:false,
      amountRegister:"10",
      //    loading:true
    };
  },
  async created() {
    await this.getData();
  },
  methods: {
    getData() {
      const url = this.appDomainApi1 + "admin/round/index"
      axios
        .post(url, { 
            register: this.amountRegister
          }, 
        )
        .then((resp) => {
          this.listRound = resp.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    search() {
      this.viewSearch=true;
      const url = this.appDomainApi1 + "admin/round/search";
      axios
        .post(
          url, { 
            search: this.searchText,
            register: this.amountRegister
          },
        )
        .then((resp) => {
          if (resp.data.code == 200) {
            this.resSearch = resp.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    searchEmail($email) {
      this.viewSearch=true;
      this.searchText = $email;
      const url = this.appDomainApi1 + "admin/round/search";
      axios
        .post(
          url, { 
            search: this.searchText,
            register: this.amountRegister
          },
        )
        .then((resp) => {
          if (resp.data.code == 200) {
            this.resSearch = resp.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
};
</script>

<style>
.imgav {
  display: flex;
  align-content: center;
  justify-content: center;
}
.cAvatar {
  position: relative;
  width: 30px;
  height: 30px;
  background-color: white;
  border-radius: 50%;
  overflow: hidden;
}
.cImage {
  position: absolute;
  width: 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.loading {
  height: 6.8em;
}
.dc1:hover {
  color: white;
  background: #628cfb;
  transition-duration: 100ms;
  cursor: pointer;
}
.dc1 {
  border-radius: 5px;
  padding-top: 15px;
  padding-bottom: 15px;
  background: #e8f0ff;
  margin: 5px;
}
.dDetalle:hover {
  color: white;
}
.dDetalle {
  padding-top: 10px;
}
.dDetalle > p {
  margin-top: 97px;
  /* margin: -15px; */
  margin-left: 6px;
  padding: 0px;
  /* border: 0px; */
  margin-top: -15px;
  font-size: 16px;
  color: #1d2b8d;
  line-height: 1.2;
}
.nutemas {
  color: black;
  margin-left: 16px;
  font-family: inherit;
  font-size: 50px;
}
</style>
